module.exports = __webpack_public_path__ + "static/media/undo.8ad31a88.svg";